import React, { ReactElement } from "react";
import {
  TextField,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Typography,
  CircularProgress,
  IconButton,
  Button,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./trendsStyle";
import {
  setAktuellerTemp,
  selectAktuellerTemp,
  setAktuellerWertTemp,
  selectAktuellerWertTemp,
  setIsAktuellerAktiv,
  selectIsAktuellerAktiv,

  setAktuellerAnstiegTemp,
  selectAktuellerAnstiegTemp,
  setAktuellerAnstiegWertTemp,
  selectAktuellerAnstiegWertTemp,
  setIsAktuellerAnstiegAktiv,
  selectIsAktuellerAnstiegAktiv,

  setAktuellerAnstiegsdauerTemp,
  selectAktuellerAnstiegsdauerTemp,
  setAktuellerAnstiegsdauerWertTemp,
  selectAktuellerAnstiegsdauerWertTemp,
  setIsAktuellerAnstiegsdauerAktiv,
  selectIsAktuellerAnstiegsdauerAktiv,

  setMittlererAnstiegTemp,
  selectMittlererAnstiegTemp,
  setMittlererAnstiegWertTemp,
  selectMittlererAnstiegWertTemp,
  setIsMittlererAnstiegAktiv,
  selectIsMittlererAnstiegAktiv,

  selectGroesserKleinerListe,
  selectCalculatedTrendsList,
  selectLoadingCalculatedTrends,
  selectselectedCalculatedTrend,
  setSelectedCalculatedTrend,
  getCalculatedTrends,
  
} from "./trendsFilterSlice";
import { analyseAnfrage } from "../../../utils/apiTypes";
import CachedIcon from '@material-ui/icons/Cached';
import { selectKennegroesse, setKenngroesseWertTemp, setSelectedGroups as setSelectedGroupsKenngroessen } from "../../../features/filter/kenngroesseSlice";
import { selectMessstellen, setMessstelleWertTemp, setSelectedGroups as setSelectedGroupsMessstellen } from "../../../features/filter/messstellenFilterSlice";

function TrendsFilter(): ReactElement {
  const dispatch = useAppDispatch();
  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const calculatedTrends = useAppSelector(selectCalculatedTrendsList);
  const isCalculatedTrendsLoading = useAppSelector(selectLoadingCalculatedTrends);
  const selectedCalculatedTrend = useAppSelector(selectselectedCalculatedTrend);

  const groesserKleinerListe = useAppSelector(selectGroesserKleinerListe);
  const aktuellerTemp = useAppSelector(selectAktuellerTemp);
  const aktuellerWertTemp = useAppSelector(selectAktuellerWertTemp);
  const isAktuellerAktiv = useAppSelector(selectIsAktuellerAktiv);
  
  const aktuellerAnstiegTemp = useAppSelector(selectAktuellerAnstiegTemp);
  const aktuellerAnstiegWertTemp = useAppSelector(selectAktuellerAnstiegWertTemp);
  const isAktuellerAnstiegAktiv = useAppSelector(selectIsAktuellerAnstiegAktiv);
 
  const aktuellerAnstiegsdauerTemp = useAppSelector(selectAktuellerAnstiegsdauerTemp);
  const aktuellerAnstiegsdauerWertTemp = useAppSelector(selectAktuellerAnstiegsdauerWertTemp);
  const isAktuellerAnstiegsdauerAktiv = useAppSelector(selectIsAktuellerAnstiegsdauerAktiv);
  
  const mittlererAnstiegTemp = useAppSelector(selectMittlererAnstiegTemp);
  const mittlererAnstiegWertTemp = useAppSelector(selectMittlererAnstiegWertTemp);
  const isMittlererAnstiegAktiv = useAppSelector(selectIsMittlererAnstiegAktiv);
  
  const kenngroessen = useAppSelector(selectKennegroesse);
  const messstellen = useAppSelector(selectMessstellen);

  const [calculatedTrendsInputvalue, setCalculatedTrendsInputvalue] = React.useState('');

  const getRenderedOption = (option: analyseAnfrage): ReactElement => {
    const start = new Date(option.start).toLocaleDateString();
    const ende = new Date(option.ende).toLocaleDateString();
    return <small>
        <b>{option.name}</b><br />
        {start} - {ende}
    </small>
  }

  return (
    <div>
      <Grid item md={12} style={{ marginBottom: "20px" }} />
      
      <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
        <Typography color="primary">Vorberechnete Trends<IconButton onClick={() => dispatch(getCalculatedTrends('-1'))} aria-label="neuladen"><CachedIcon /></IconButton></Typography>
        <Autocomplete
            id="select-calculatedTrends"
            noOptionsText={<React.Fragment>{isCalculatedTrendsLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Auswahl"}</React.Fragment>}
            value={selectedCalculatedTrend}
            options={calculatedTrends}
            onChange={(_, newValue) => {
                dispatch(setSelectedCalculatedTrend(newValue ?? {} as analyseAnfrage));
                //dispatch(setIsChangedTrends(true));
                if (newValue) {
                  const messstellenForTrend = messstellen.filter(x => newValue.messstellen.includes(x.name));
                  dispatch(setMessstelleWertTemp(messstellenForTrend));
                  dispatch(setSelectedGroupsMessstellen(messstellenForTrend.filter((x) => {
                    const allMessstellenForThisUW = messstellen.filter((mv) => mv.umspannwerk == x.umspannwerk).length;
                    const selectedMessstellenForThisUW = messstellenForTrend.filter((mv) => mv.umspannwerk == x.umspannwerk).length;
                    return (
                      allMessstellenForThisUW == selectedMessstellenForThisUW
                    );
                  }).map((x) => x.umspannwerk)));

                  const kenngroessenForTrend = kenngroessen.filter(x => newValue.kenngroessen.includes(x.feldname));
                  dispatch(setKenngroesseWertTemp(kenngroessenForTrend));
                  dispatch(setSelectedGroupsKenngroessen(kenngroessenForTrend.filter((x) => {
                    const allKenngroesseForThisKat = kenngroessen.filter((kr) => kr.unterkategorie == x.unterkategorie).length;
                    const selectedKenngroesseForThisKat = kenngroessenForTrend.filter((kr) => kr.unterkategorie == x.unterkategorie).length;
                    return (
                      allKenngroesseForThisKat == selectedKenngroesseForThisKat
                    );
                  }).map((x) => x.unterkategorie as string)));
                }
            }}
            inputValue={calculatedTrendsInputvalue}
            onInputChange={(_, nV) => setCalculatedTrendsInputvalue(nV)}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label="Auswahl"
                    variant="outlined"
                    InputLabelProps={{ ...params.InputLabelProps }}
                    InputProps={{ ...params.InputProps }}
                />}
            getOptionLabel={(option) => option.name}
            renderOption={(option) => {
                return getRenderedOption(option);
            }}
            className={classes.selectEmpty}
            style={{ marginBottom: "25px" }}
        />
      </Grid>

      {selectedCalculatedTrend?.id > 0 ?
      <React.Fragment>
        <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
          <FormGroup row>
            <FormControlLabel
              style={{ marginRight: "30px" }}
              control={
                <Checkbox
                  checked={isAktuellerAktiv}
                  onChange={(e, nV) =>
                    nV
                      ? dispatch(setIsAktuellerAktiv(true))
                      : dispatch(setIsAktuellerAktiv(false))
                  }
                />
              }
              label="Aktueller Wert"
            />
          </FormGroup>
          {isAktuellerAktiv ? (
            <Grid container item md={12}>
              <Grid item md={6} style={{ paddingRight: "15px" }}>
                <Autocomplete
                  id="select-aktueller"
                  value={aktuellerTemp}
                  options={groesserKleinerListe}
                  getOptionLabel={(option) => option}
                  onChange={(event, nV) => {
                    dispatch(setAktuellerTemp(nV != null ? nV : ""));
                    // dispatch(setIsChangedTrends(true));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Größer/ Kleiner"
                      variant="outlined"
                      InputLabelProps={{ ...params.InputLabelProps }}
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                  className={classes.selectEmpty}
                />
              </Grid>
              <Grid item md={6}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="aktueller-eingabe"
                    label="Eingabe Zahl"
                    variant="outlined"
                    type="number"
                    inputProps={{
                      step: "0.01",
                      lang: "en-US",
                    }}
                    onChange={(event) => {
                      const inputValue = Number(
                        event.target.value.replace(/[^0-9.]/g, "")
                      );
                      dispatch(setAktuellerWertTemp(Number(inputValue)));
                      // dispatch(setIsChangedTrends(true));
                    }}
                    value={aktuellerWertTemp}
                    className={classes.selectEmpty}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            ""
          )} 
        </Grid>

        <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
          <FormGroup row>
            <FormControlLabel
              style={{ marginRight: "30px" }}
              control={
                <Checkbox
                  checked={isAktuellerAnstiegAktiv}
                  onChange={(e, nV) =>
                    nV
                      ? dispatch(setIsAktuellerAnstiegAktiv(true))
                      : dispatch(setIsAktuellerAnstiegAktiv(false))
                  }
                />
              }
              label="Aktueller Anstieg"
            />
          </FormGroup>
          {isAktuellerAnstiegAktiv ? (
            <Grid container item md={12}>
              <Grid item md={6} style={{ paddingRight: "15px" }}>
                <Autocomplete
                  id="select-aktueller-anstieg"
                  value={aktuellerAnstiegTemp}
                  options={groesserKleinerListe}
                  getOptionLabel={(option) => option}
                  onChange={(event, nV) => {
                    dispatch(setAktuellerAnstiegTemp(nV != null ? nV : ""));
                    // dispatch(setIsChangedTrends(true));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Größer/ Kleiner"
                      variant="outlined"
                      InputLabelProps={{ ...params.InputLabelProps }}
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                  className={classes.selectEmpty}
                />
              </Grid>
              <Grid item md={6}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="aktueller-anstieg-eingabe"
                    label="Eingabe Zahl"
                    variant="outlined"
                    type="number"
                    inputProps={{
                      step: "0.01",
                      lang: "en-US",
                    }}
                    onChange={(event) => {
                      const inputValue = Number(
                        event.target.value.replace(/[^0-9.]/g, "")
                      );
                      dispatch(setAktuellerAnstiegWertTemp(Number(inputValue)));
                      // dispatch(setIsChangedTrends(true));
                    }}
                    value={aktuellerAnstiegWertTemp}
                    className={classes.selectEmpty}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            ""
          )} 
        </Grid>

        <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
          <FormGroup row>
            <FormControlLabel
              style={{ marginRight: "30px" }}
              control={
                <Checkbox
                  checked={isAktuellerAnstiegsdauerAktiv}
                  onChange={(e, nV) =>
                    nV
                      ? dispatch(setIsAktuellerAnstiegsdauerAktiv(true))
                      : dispatch(setIsAktuellerAnstiegsdauerAktiv(false))
                  }
                />
              }
              label="Aktuelle Anstiegsdauer"
            />
          </FormGroup>
          {isAktuellerAnstiegsdauerAktiv ? (
            <Grid container item md={12}>
              <Grid item md={6} style={{ paddingRight: "15px" }}>
                <Autocomplete
                  id="select-aktueller-anstiegsdauer"
                  value={aktuellerAnstiegsdauerTemp}
                  options={groesserKleinerListe}
                  getOptionLabel={(option) => option}
                  onChange={(event, nV) => {
                    dispatch(setAktuellerAnstiegsdauerTemp(nV != null ? nV : ""));
                    // dispatch(setIsChangedTrends(true));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Größer/ Kleiner"
                      variant="outlined"
                      InputLabelProps={{ ...params.InputLabelProps }}
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                  className={classes.selectEmpty}
                />
              </Grid>
              <Grid item md={6}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="aktueller-anstiegsdauer-eingabe"
                    label="Eingabe Zahl"
                    variant="outlined"
                    type="number"
                    inputProps={{
                      step: "0.01",
                      lang: "en-US",
                    }}
                    onChange={(event) => {
                      const inputValue = Number(
                        event.target.value.replace(/[^0-9.]/g, "")
                      );
                      dispatch(setAktuellerAnstiegsdauerWertTemp(Number(inputValue)));
                      // dispatch(setIsChangedTrends(true));
                    }}
                    value={aktuellerAnstiegsdauerWertTemp}
                    className={classes.selectEmpty}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            ""
          )} 
        </Grid>

        <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
          <FormGroup row>
            <FormControlLabel
              style={{ marginRight: "30px" }}
              control={
                <Checkbox
                  checked={isMittlererAnstiegAktiv}
                  onChange={(e, nV) =>
                    nV
                      ? dispatch(setIsMittlererAnstiegAktiv(true))
                      : dispatch(setIsMittlererAnstiegAktiv(false))
                  }
                />
              }
              label="Mittlerer Anstieg"
            />
          </FormGroup>
          {isMittlererAnstiegAktiv ? (
            <Grid container item md={12}>
              <Grid item md={6} style={{ paddingRight: "15px" }}>
                <Autocomplete
                  id="select-mittlerer-anstieg"
                  value={mittlererAnstiegTemp}
                  options={groesserKleinerListe}
                  getOptionLabel={(option) => option}
                  onChange={(event, nV) => {
                    dispatch(setMittlererAnstiegTemp(nV != null ? nV : ""));
                    // dispatch(setIsChangedTrends(true));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Größer/ Kleiner"
                      variant="outlined"
                      InputLabelProps={{ ...params.InputLabelProps }}
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                  className={classes.selectEmpty}
                />
              </Grid>
              <Grid item md={6}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="mittlerer-anstieg-eingabe"
                    label="Eingabe Zahl"
                    variant="outlined"
                    type="number"
                    inputProps={{
                      step: "0.01",
                      lang: "en-US",
                    }}
                    onChange={(event) => {
                      const inputValue = Number(
                        event.target.value.replace(/[^0-9.]/g, "")
                      );
                      dispatch(setMittlererAnstiegWertTemp(Number(inputValue)));
                      // dispatch(setIsChangedTrends(true));
                    }}
                    value={mittlererAnstiegWertTemp}
                    className={classes.selectEmpty}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            ""
          )} 
        </Grid>
      </React.Fragment> : "" }
    </div>
  );
}

export default TrendsFilter;
 